import { useEffect, useState } from 'react';
import type { MapRef } from 'react-map-gl/mapbox';

/**
 * HACK (DISCO-17246): Forces a re-render when the map style changes.
 * The map object's style is not updated when the style changes (sometimes), causing `getLayerBeforeId` to return layer values
 * that may not be valid with the map's current style.
 * By forcing a re-render when style changes, we ensure that the beforeId is updated to the correct value.
 */
const useMapStyleChange = (map: MapRef | undefined) => {
  const [currentStyle, setCurrentStyle] = useState<string | undefined>();

  useEffect(() => {
    const handleStyleData = () => {
      const newStyle = map?.getStyle()?.name ?? undefined;
      if (newStyle !== currentStyle) {
        setCurrentStyle(newStyle);
      }
    };
    map?.on('styledata', handleStyleData);
    return () => {
      map?.off('styledata', handleStyleData);
    };
  }, [map, currentStyle]);

  return currentStyle;
};

export default useMapStyleChange;
